import React from 'react'

const TabTitle = () => {
    return (
      <>
        <div className='tabtitle'>
          <p>
            Each of the following tabs will display its own set of insights and
            questions:
          </p>
        </div>
      </>
    );
}

export default TabTitle
